import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UxError } from 'src/app/models/ux-error.model';
import {
  KnowledgeAttentionSection,
  KnowledgeExpirationItem,
} from 'src/app/models/home/knowledge-attention/knowledge-attention.model';
import { LanguageService } from 'src/app/services/language/language.service';

/**
 * Home IA · Radar de conocimiento R4 (K6). Widget "Próximos vencimientos documentales": top-N de
 * vencimientos R4 (evidencia breve, fecha, tipo) con deep-link a `/knowledge/vencimientos`.
 * READ-ONLY: no gestiona ni descarta vencimientos (eso vive en `/knowledge`). Se oculta por
 * completo si el plan no tiene `knowledge_hub` (featureAvailable=false). Degrada de forma
 * independiente del widget de entidades (usa su propio `section.status`).
 */
@Component({
  selector: 'app-home-knowledge-expirations',
  templateUrl: './home-knowledge-expirations.component.html',
  styleUrls: ['./home-knowledge-expirations.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HomeKnowledgeExpirationsComponent {
  @Input() section: KnowledgeAttentionSection<KnowledgeExpirationItem> | null = null;
  @Input() featureAvailable = false;
  @Input() loading = false;
  @Input() error: UxError | null = null;
  @Output() retryRequest = new EventEmitter<void>();

  readonly knowledgeLink = '/knowledge/vencimientos';

  constructor(public lang: LanguageService) {}

  get items(): KnowledgeExpirationItem[] {
    return this.section?.items ?? [];
  }

  /** Error si falla la llamada entera O sólo esta sección (degradación parcial). */
  get hasError(): boolean {
    return !!this.error || this.section?.status === 'error';
  }

  get isEmpty(): boolean {
    return !this.loading && !this.hasError && (this.section?.status === 'empty' || this.items.length === 0);
  }

  onRetry(): void {
    this.retryRequest.emit();
  }
}
